"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getBrowserKey = void 0;
// We are using the to avoid collisions when using app configs in a browser
// We are relying on process.env here and will replace it with the value needed via webpack
var id = 'APP';

try {
  // nw-app-build < 4.34.0 will throw an error when accessing process.env.BROWSER_APP_CONFIG_ID
  // as this code runs before we've defined window.nerdwallet.config variables
  id = process.env.BROWSER_APP_CONFIG_ID || process.env.CLIENT_ID || '';
} catch (e) {} // eslint-disable-line no-empty


if (!id) {
  throw new Error('Could not determine ID');
}

var key = "__NW_APP_CONFIG--".concat(id.toUpperCase(), "__");

var getBrowserKey = function getBrowserKey() {
  return key;
};

exports.getBrowserKey = getBrowserKey;
var _default = key;
exports.default = _default;